import ObjectID from "bson-objectid";
import { EDCOMP_EQN_MULTILINE, EDCOMP_EQUATION, EDCOMP_FIGURE, EDCOMP_INT_FIGURE, EDCOMP_INT_FIGURE_DISCRETE, EDCOMP_MULTIFIGURE, EDCOMP_PARAG, EDCOMP_PROBLEM_SET } from "../../constants/frameConstants";

export const add_link = (text_in, references, link_position) =>{
    if(text_in===undefined)
    {
        return text_in ; 
    }
    const regex = /(figure|equation)\s*\\ref\{([^}]*)\}\{[^}]*\}/gi;
    var text_out  = text_in.replace(regex, (match, type, ref_string) =>{
        // Find reference string from reference ID
        var matching_reference_index = references.findIndex(item => {return item.label === ref_string});
        if(matching_reference_index >=0){
            // If close, then put in dummy link to smuggle stuff in to UCL
            if(Math.abs(link_position-references[matching_reference_index].item_position)<=0)
            {
                return '['+match+'](https://internal-link2/'+references[matching_reference_index]._id+')'
            }
            else
            {
                return '['+match+'](https://internal-link2/'+references[matching_reference_index]._id+')'
            }
        }
        else{
            return match ; 
        }
    })
    return text_out ; 
}



// Makes references to equations and figures and adds links into main document so can open in the support panel
export const link_support_references=(data)=>{

    // Run through whole content, adding equations and figures to support contentsf
    data.references = [] ; 

    var item_position = 0;
    // Create references to every equation, figure etc. and store at base level of content object.
    for (var c_section = 0; c_section < data.content.length; c_section++){
        for(var c_subsection = 0; c_subsection < data.content[c_section].subsections.length; c_subsection++){
            for(var c_frame = 0; c_frame < data.content[c_section].subsections[c_subsection].frames.length; c_frame++){
                item_position++ ; 
                for (var c_content_item = 0; c_content_item < data.content[c_section].subsections[c_subsection].frames[c_frame].contents.length; c_content_item++){
                    switch(data.content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content_item].type)
                    {
                        case EDCOMP_EQN_MULTILINE:
                        case EDCOMP_EQUATION:
                        case EDCOMP_FIGURE:
                        case EDCOMP_MULTIFIGURE:
                        case EDCOMP_INT_FIGURE:
                        case EDCOMP_INT_FIGURE_DISCRETE:
                            const reference = {section: c_section, subsection: c_subsection, frame: c_frame, content_item: c_content_item,
                                    label:  data.content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content_item].data.label,
                                        _id: ObjectID().toHexString(), item_position:item_position}
                            data.references.push(reference)
                            break ;
                        default:
                            continue; 
                    }
                }
            }
        }
    }
   




    var link_position = 0 ;
    // Now run through a second time, replacing references to figures with support links
    for (c_section = 0; c_section < data.content.length; c_section++){
        for(c_subsection = 0; c_subsection < data.content[c_section].subsections.length; c_subsection++){
            for(c_frame = 0; c_frame < data.content[c_section].subsections[c_subsection].frames.length; c_frame++){
                link_position++ ; 
                for (c_content_item = 0; c_content_item < data.content[c_section].subsections[c_subsection].frames[c_frame].contents.length; c_content_item++){
                    switch(data.content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content_item].type){
                        case EDCOMP_FIGURE:
                        case EDCOMP_PARAG:
                            data.content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content_item].data.text=
                            add_link(data.content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content_item].data.text, data.references, link_position)
                            break;
                        case EDCOMP_PROBLEM_SET:
                            for (var c_problem = 0; c_problem < data.content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content_item].data.problems.length; c_problem++){
                                data.content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content_item].data.problems[c_problem].question =
                                    add_link(data.content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content_item].data.problems[c_problem].question, data.references, link_position)
                                data.content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content_item].data.problems[c_problem].question2 =
                                    add_link(data.content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content_item].data.problems[c_problem].question2, data.references, link_position)
                                data.content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content_item].data.problems[c_problem].answer =
                                    add_link(data.content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content_item].data.problems[c_problem].answer, data.references, link_position)
                            }

                        break; 

                        default:
                            continue; 

                    }
                }
            }
        }
    }




    return data ; 

}